import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/ivslogo.png';
import './navbar.css';
import { Selection, Form, Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="ishs__navbar">
      <div className="ishs__navbar-links">
        <div className="ishs__navbar-links_logo">
          <img src={logo} />
        </div>
        <div className="ishs__navbar-links_container">
          <p><a href="/">Home</a></p>
          <p><a href="#ishs">What is ISHS?</a></p>
          <p><a href="/ishs">Dashboard</a></p>
          <p><a href="https://www.ivssofttech.com/shop" target="_blank">Buy</a></p>
          <p><a href="https://www.ivssofttech.com/contact-us/" target="_blank">Contact</a></p>
        </div>
      </div>
      <div className="ishs__navbar-sign">
      <p><a href="/ishs">My Account</a></p>
      
      </div>
      <div className="ishs__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="ishs__navbar-menu_container scale-up-center">
        <div className="ishs__navbar-links_container">
          <p><a href="/">Home</a></p>
          <p><a href="#ishs">What is ISHS?</a></p>
          <p><a href="/ishs">Dashboard</a></p>
          <p><a href="#buy">Buy</a></p>
          <p><a href="#contact">Contact</a></p>
        </div>
          <div className="ishs__navbar-menu_container-links-sign">
          <p><a href="/ishs">My Account</a></p>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
